var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site doks",attrs:{"id":"page"}},[_c('a',{attrs:{"href":"#main","aria-label":"Idź do treści"}}),_c('app-header'),_c('router-view',{attrs:{"id":"main"}}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }